import { color, createStyles, makeStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useKioskFormStyles = makeStyles((theme: MuiTheme) =>
  createStyles({
    kioskDetailsHeaders: {
      lineHeight: '1.13',
      fontSize: '16px',
      fontWeight: 600,
      cursor: 'pointer'
    },
    tableFirstCell: {
      paddingLeft: 24
    },
    tableActionsCell: {
      textAlign: 'center',
      '& .actionsContainer': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px'
      }
    },
    formInnerContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'transparent'
    },
    formInputBox: {
      background: 'transparent',
      height: '120px',
      minWidth: '100%',
      display: 'flex',
      gap: '1rem',
      [theme.breakpoints.down('xs')]: {
        height: '110px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    formOverlayInputBox: {
      background: 'transparent',
      height: '100px',
      minWidth: '100%',
      [theme.breakpoints.down('xs')]: {
        height: '80px'
      },
      '& > * > * > input': {
        [theme.breakpoints.down('xs')]: {
          height: '40px'
        }
      }
    },
    formDropdownLabel: {
      margin: '0px 0px 10px',
      fontSize: '16px',
      fontWeight: 'bold',
      paddingLeft: '16px'
    },
    formDropdownIconHeadLabel: {
      fontSize: '16px',
      fontWeight: 'bold',
      height: '20px',
      paddingLeft: '16px',
      marginBottom: '10px',
      alignItems: 'center'
    },
    kioskPopUpTableOuterBox: {
      flex: 'none',
      background: 'transparent'
    },
    kioskPopUpTableContainer: {
      minHeight: '100px',
      maxHeight: '350px',
      [theme.breakpoints.down('sm')]: {
        height: '370px'
      }
    },
    filtersMultiSelect: {
      width: '100%',
      height: '45px',
      borderRadius: '50px',
      border: `2px solid ${color.BLACK}`,
      color: 'grey',
      '& .MuiSelect-select': {
        padding: '26px'
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px !important'
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: color.BLACK
      },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: color.BLACK
      }
    }
  })
);
